module.exports = __webpack_public_path__ + "img/43_11.bdfefc78.png";